import type { NavThemeComponentsInterface } from '~/types/AppData/Theme/NavThemeComponentsInterface';

export const SI_TOP_NAV_THEME: NavThemeComponentsInterface = {
  BackgroundColor: { type: 'COLOR', value: 'black' },
  HeightInSmallScreen: { type: 'FACTOR', value: 2 },
  HeightInMediumScreen: { type: 'FACTOR', value: 2 },
  HeightInLargeScreen: { type: 'FACTOR', value: 1.5 },
  LogoHeightInSmallScreen: { type: 'FACTOR', value: 1 },
  LogoHeightInMediumScreen: { type: 'FACTOR', value: 1 },
  LogoHeightInLargeScreen: { type: 'FACTOR', value: 1 },
  LinkFontSizeLarge: { type: 'TYPOGRAPHY', value: 'tiny' },
  LinkFontSizeMedium: { type: 'TYPOGRAPHY', value: 'tiny' },
  LinkFontSizeSmall: { type: 'TYPOGRAPHY', value: 'tiny' },
  LinkColorTypeNormal: { type: 'COLOR', value: 'white' },
  LinkColorTypeHover: { type: 'COLOR', value: 'white' },
  LinkCurrentColor: { type: 'COLOR', value: 'white' },
  LinkColorTypeActive: { type: 'COLOR', value: 'white' },
  LinkActiveBorderBottom: { type: 'COLOR', value: 'white' },
  LinkHoverUnderline: { type: 'BOOLEAN', value: true },
  HoverOtherLinksColors: { type: 'COLOR', value: 'white' },
  LinkDropdownIconColor: { type: 'COLOR', value: 'white' },
  SocialLinksColor: { type: 'COLOR', value: 'white' },
  SocialLinksHoverColor: { type: 'COLOR', value: 'white' },
  BoxShadow: { type: 'BOX_SHADOW', value: 'LOW' },
  SubMenuBackgroundColor: { type: 'COLOR', value: 'black' },
  SubMenuLinksFontSize: { type: 'TYPOGRAPHY', value: 'tiny' },
  ColumnGap: { type: 'FACTOR', value: 0.75 },
};
